<div class="particle-container">
  <h2>
    <span>
      <mat-icon fontIcon="format_quote" class="quote-start"></mat-icon>
      <span class="generating">AI Generating: </span>
      {{ promptName }}
      <mat-icon fontIcon="format_quote" class="quote-end"></mat-icon>
      @if (showSlowLLMMessage || typedSlowLLMMessage) {
        <div>
          @if (!typedSlowLLMMessage) {
            <div class="circle-typing"></div>
          }
          <div id="slow-llm-message" [innerHTML]="typedSlowLLMMessage"></div>
        </div>
      }
    </span>
  </h2>
  <div class="particles">
    @for (i of noOfCircles; track $index) {
      <span class="circle"></span>
    }
    @for (i of noOfDashedCircles; track $index) {
      <span class="dashed-circle"></span>
    }
    <span class="svg-kyloe-logo-particle" (dblclick)="typeSlowMessage()">
      <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" fill-opacity="1" viewBox="0 0 163.2 159.88">
        <defs>
          <style>.cls-1{fill:#ce0058;}</style>
        </defs>
        <path class="cls-1" d="M94,94.84c4.41,5.92,11.67,9.18,19.17,9.32l8.68.15a39.36,39.36,0,0,1,20-5.32,38.41,38.41,0,0,1,20.8,6l6.83-.12c7.72-.14,15.19-3.49,19.73-9.59A22.71,22.71,0,0,0,194,80.58c0-.77.11-1.2.38-1.36-13.9-11-32-17.43-52.54-17.43-20.79,0-39,6.39-52.93,17.45.26.16.39.57.36,1.3A22.08,22.08,0,0,0,94,94.84Z" transform="translate(-60.13 -61.79)"/>
        <path class="cls-1" d="M198.79,83.06c3.05,4.28,6.43,11.13,6.43,16,0,12.5-8.86,23-21.3,27.26a5,5,0,0,0-3.37,5.74,54.45,54.45,0,0,1,1,9.72,43.23,43.23,0,0,1-13.09,32.12,1.13,1.13,0,0,0-.29,1.15c2.7,10.41-10.19,19.41-26.46,19.41s-29.15-9-26.47-19.4a1.15,1.15,0,0,0-.31-1.17c-2.54-2.27-13.06-12.8-13-32.11A50.42,50.42,0,0,1,103.1,131a5,5,0,0,0-3.44-5.85c-12.36-4-21.22-14.37-21.22-26.69,0-4.65,3.26-11.27,6.2-15.43-15.36,14.25-24.51,34.73-24.51,58.71,0,46.43,34.12,79.94,81.75,79.94,47,0,81.45-33.51,81.45-79.94C223.33,117.78,214.12,97.31,198.79,83.06Z" transform="translate(-60.13 -61.79)"/>
      </svg>
    </span>
  </div>
</div>
